import { useSelector, useDispatch } from 'react-redux';

import { getPagination, setPagination, getPageIndex, setPageIndex } from '../scenes/dataSet';

const usePreviewTablePaginationState = () => {
  // step 1: Get value using useSelector Hook
  const pagination = useSelector(state => getPagination(state));

  // step 2: Create Setter using useDispatch Hook
  const dispatch = useDispatch();
  const setter = newPagination => {
    dispatch(setPagination(newPagination));
  };

  return [pagination, setter];
};

const usePreviewTablePageIndexState = () => {
  // step 1: Get value using useSelector Hook
  const pageIndex = useSelector(state => getPageIndex(state));

  // step 2: Create Setter using useDispatch Hook
  const dispatch = useDispatch();
  const setter = newIndex => {
    dispatch(setPageIndex(newIndex));
  };

  return [pageIndex, setter];
};

export {
  usePreviewTablePaginationState,
  usePreviewTablePageIndexState
};
